import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [
    {
        path: 'premium-terms',
        name: routeName.PREMIUM_TERMS,
        component: () => import('@/views/aplCatl640and631/A1/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '目標/計畫保費、配置比例暨繳別變更說明', leaveAlert: true, code: 'A1', unableBack: true },
    },
    {
        path: 'premium',
        name: routeName.PREMIUM,
        component: () => import('@/views/aplCatl640and631/A1/premiumPlanning/Index.vue'),
        meta: { auth: true, metaTitle: '目標/計畫保費、配置比例暨繳別變更', leaveAlert: true, code: 'A1', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.PREMIUM_TERMS, routeName.CONFIRM_DATA];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    }
];

export default routes;
